import React, { useContext } from 'react';
import BaseApp from '../base_app';
import { IndexData } from '../../common/index-context';
import steps from './steps';

const App = ({ projectId, redirectPath, texts }) => {
  const {
    setForceOpenFilterDropDown, getCustomTourFunctions, setForceOpenButton
  } = useContext(IndexData);

  const stepsFunc = steps({
    setForceOpenFilterDropDown,
    getCustomTourFunctions,
    setForceOpenButton
  });


  return (
    <BaseApp
      projectId={ projectId }
      redirectPath={ redirectPath }
      texts={ texts }
      steps={ stepsFunc }
      tourName="brand-snapshot"
    />
  );
};


export default App;
